import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export function AnswerSynthesisInfoTooltip() {
  return (
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="text-muted-foreground hover:text-foreground transition-colors"
            aria-label="About answer synthesis keys"
          >
            <Info className="h-4 w-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="right" className="max-w-xs text-xs leading-relaxed">
          <p className="font-semibold mb-1">Bring Your Own Key (BYOK)</p>
          <p>
            Answer synthesis calls the OpenAI API. Paid plans receive 100 free lifetime calls
            using Gateco&apos;s shared key. After that, add your own OpenAI key, encrypted
            with AES-256-GCM before storage, wrapped in a per-organization KMS data key so
            only your org can decrypt it.
          </p>
        </TooltipContent>
      </Tooltip>
  );
}
